import StoreUtil from '@/store/StoreUtil'

export default {
  SET_OPPORTUNITIES: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.tracker,
    'setOpportunities'
  ),
  SET_ERROR: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.tracker,
    'setError'
  ),
}
